import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap'
import { FaPlus } from 'react-icons/lib/fa'

class CreateFragmetModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      title: '',
      modal: false
    }
  }

  toggle = () => {
    this.setState({ modal: !this.state.modal })
  }

  changeTitle = (e) => {
    this.setState({ title: e.target.value })
  }

  create = () => {
    this.props.create(this.state.title)
  }

  onKeyDown = (synthetic) => {
    // return
    if (synthetic.keyCode === 13) {
      this.props.create(this.state.title)
    }
  }

  render () {
    return (
      <div>
        <Button color='primary' onClick={this.toggle}><FaPlus /> New Fragment</Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>Create new fragment</ModalHeader>
          <ModalBody onKeyDown={this.onKeyDown}>
            <Input size='lg' placeholder='Page Title' onChange={this.changeTitle} disabled={this.props.isSaving} />
          </ModalBody>
          <ModalFooter>
            <Button color='primary' onClick={this.create} disabled={this.props.isSaving}>Create</Button>
            &nbsp;
            <Button color='secondary' onClick={this.toggle} disabled={this.props.isSaving}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
CreateFragmetModal.propTypes = {
  create: PropTypes.func.isRequired,
  isSaving: PropTypes.bool
}

export default CreateFragmetModal



// WEBPACK FOOTER //
// ./src/components/CreateFragmetModal/CreateFragmetModal.js